export default __webpack_public_path__ + "static/media/8.b1cbb6f4.mp3";